import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Show success message and redirect after a short delay
    console.log("SuccessPage mounted, redirecting to /businesses shortly...");
    const timer = setTimeout(() => {
      navigate('/businesses');
    }, 2000); // Redirect after 2 seconds

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
    
  }, [navigate]); // Depend on navigate

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        background: 'linear-gradient(135deg, #f8f9fe 0%, #ffffff 100%)',
      }}
    >
      <CircularProgress size={60} thickness={4} sx={{ mb: 4 }} />
      <Typography variant="h5" align="center" gutterBottom>
        Payment Successful!
      </Typography>
      <Typography variant="body1" align="center" color="textSecondary" sx={{ mb: 4 }}>
        Redirecting you to your businesses dashboard...
      </Typography>
    </Box>
  );
};

export default SuccessPage;
